(() => {
 function update(section) {
  const rail=section.querySelector('.latea-rail');
  if(!rail)return;
  const buttons=section.querySelectorAll('[data-latea-scroll]');
  buttons.forEach(button=>{button.disabled=Number(button.dataset.lateaScroll)<0?rail.scrollLeft<=2:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;});
 }
 function init(root=document) {
  root.querySelectorAll('.latea-products').forEach(section=>{
   if(section.dataset.lateaReady)return;
   section.dataset.lateaReady='true';
   const rail=section.querySelector('.latea-rail');
   if(!rail)return;
   section.querySelectorAll('[data-latea-scroll]').forEach(button=>button.addEventListener('click',()=>{
    const card=rail.querySelector('.latea-card');
    const gap=parseFloat(getComputedStyle(rail).gap)||0;
    const step=card?card.getBoundingClientRect().width+gap:rail.clientWidth;
    rail.scrollBy({left:Number(button.dataset.lateaScroll)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   }));
   rail.addEventListener('scroll',()=>update(section),{passive:true});
   if('ResizeObserver' in window)new ResizeObserver(()=>update(section)).observe(rail);
   update(section);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();


(() => {
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-latea-back]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    let previousUrl = '';
    try {
      if (window.navigation?.currentEntry) {
        const index = window.navigation.currentEntry.index;
        previousUrl = window.navigation.entries()[index - 1]?.url || '';
      } else if (window.history.length > 1) {
        previousUrl = document.referrer;
      }
      if (previousUrl && new URL(previousUrl, window.location.href).origin === window.location.origin) {
        event.preventDefault();
        window.history.back();
      }
    } catch {}
  });
})();
